import Vue from "vue"
import * as utils from "@/Shared/utils"

export default new Vue({
  name: "ProvidersService",
  data: {},
  methods: {
    /**
     * addClientOnlyFields - adds below list of fiels
     *  '_updated'
     *  '_added'
     * @param {array} itemsList
     * @returns {array}
     */
    addClientOnlyFields(itemsList) {
      if (!this.$lodash.isArray(itemsList)) {
        return
      }
      let itemObj
      for (let index in itemsList) {
        itemObj = itemsList[index]
        itemObj["_updated"] = !this.$lodash.isNull(itemObj.updated)
          ? utils.getLocalDateTime(itemObj.updated)
          : ""
        itemObj["_added"] = !this.$lodash.isNull(itemObj.added)
          ? utils.getLocalDateTime(itemObj.added)
          : ""
      }
      return itemsList
    }
  }
})



// WEBPACK FOOTER //
// ./src/Providers/ProvidersService.js